export default __webpack_public_path__ + "static/media/ring-on-it.92e1cad6.gif";